import { HOT_TOPIC_FALLBACK_NAMES } from '@conversed/shared/src/central/constants/hot-topics';
import i18n from '../config/i18n';

/**
 * Hot topic names are stored in a single language in Core, so the auto-created fallback
 * topic ("Undefined") is translated at display time instead of being renamed in the
 * database - renaming it would break the classifier, which resolves the topic by name.
 * Every place that prints a hot topic name to the user goes through this helper.
 */
export const getHotTopicDisplayName = (name: string): string => {
  const isFallbackName = HOT_TOPIC_FALLBACK_NAMES.some(
    (fallbackName) => fallbackName.toLowerCase() === name.toLowerCase(),
  );
  return isFallbackName ? i18n.t('hot-topics.fallback-name') : name;
};
